import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import backendOption from './i18next-backend';
import sprintf from 'i18next-sprintf-postprocessor';
//import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(XHR)
    .use(sprintf)
    .init({
        backend: backendOption,
        nsSeparator: ';',
        whitelist: ['en', 'ms', 'ms-MY'],
        fallbackLng: false,

        // have a common namespace used around the full app
        ns: ['common'],
        defaultNS: 'common',

        debug: false,

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ',',
            format: function(value, format, lng) {
                if (format === 'uppercase') return value.toUpperCase();
                return value;
            }
        }
    })

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js